import { Component, OnInit } from '@angular/core';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../providers/login.service';
import { FormControl, Validators } from '@angular/forms';
import { createSession } from '../../common/sessionHandler';
import { ApiPromisefactory } from '../../providers/promise.factory';
import { CommonService } from '../../providers/common.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-introductionmodule',
    templateUrl: './introductionmodule.html',
    styleUrls: ['../bleclassmodule/bleclassmodule.css','./introductionmodule.scss']
  })


export class IntroductionComponent{

  cols:number;

  constructor(private commonsvc: CommonService,
    public router: Router,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.cols = (window.innerWidth <= 700) ? 1 : 2;
  }

  onResize(event) {
    this.cols = (event.target.innerWidth <= 700) ? 1 : 2;
  }

  goGetStartedPage(page){
    console.log(page);
    if(page=="ble")
      this.router.navigate(['/getstartedble']);
    else if(page=="qr")
      this.router.navigate(['/getstartedqr']);
  }

  goBleExamplePage(){
    this.router.navigate(['/example-SGBLEConnect'])
  }

  goQrExamplePage(){
    this.router.navigate(['/example-SGQRConnect'])
  }

}
